import { vueLang } from '@erag/lang-sync-inertia/vue';

/**
 * Frontend translation helpers backed by Laravel lang files synced via
 * `syncLangFiles()` (see app/Http/Middleware/SetLocale.php).
 *
 * Usage:
 * ```ts
 * const { __, trans, transChoice } = useI18n();
 *
 * __('common.save');
 * trans('contacts.welcome', { name: 'Jane' });
 * transChoice('messages.unread', 3);
 * ```
 */
export function useI18n() {
    return vueLang();
}
